import { render } from "./ContentLayanan.vue?vue&type=template&id=360c65c3&scoped=true"
import script from "./ContentLayanan.vue?vue&type=script&lang=js"
export * from "./ContentLayanan.vue?vue&type=script&lang=js"

import "./ContentLayanan.vue?vue&type=style&index=0&id=360c65c3&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-360c65c3"]])

export default __exports__